/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PatientProfileDto
 */
export interface PatientProfileDto {
    /**
     * First name
     * @type {string}
     * @memberof PatientProfileDto
     */
    firstName: string;
    /**
     * Middle name
     * @type {string}
     * @memberof PatientProfileDto
     */
    middleName?: string;
    /**
     * Last name
     * @type {string}
     * @memberof PatientProfileDto
     */
    lastName: string;
    /**
     * Gender
     * @type {string}
     * @memberof PatientProfileDto
     */
    gender: PatientProfileDtoGenderEnum;
    /**
     * Other gender value when gender is 'other'
     * @type {string}
     * @memberof PatientProfileDto
     */
    genderOther?: string;
    /**
     * Birth date (YYYY-MM-DD)
     * @type {string}
     * @memberof PatientProfileDto
     */
    birthDate: string;
    /**
     * Is practice owner
     * @type {boolean}
     * @memberof PatientProfileDto
     */
    isPracticeOwner?: boolean;
}


/**
 * @export
 */
export const PatientProfileDtoGenderEnum = {
    Male: 'male',
    Female: 'female',
    Other: 'other',
    Unknown: 'unknown'
} as const;
export type PatientProfileDtoGenderEnum = typeof PatientProfileDtoGenderEnum[keyof typeof PatientProfileDtoGenderEnum];


/**
 * Check if a given object implements the PatientProfileDto interface.
 */
export function instanceOfPatientProfileDto(value: object): value is PatientProfileDto {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('gender' in value) || value['gender'] === undefined) return false;
    if (!('birthDate' in value) || value['birthDate'] === undefined) return false;
    return true;
}

export function PatientProfileDtoFromJSON(json: any): PatientProfileDto {
    return PatientProfileDtoFromJSONTyped(json, false);
}

export function PatientProfileDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientProfileDto {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'],
        'middleName': json['middleName'] == null ? undefined : json['middleName'],
        'lastName': json['lastName'],
        'gender': json['gender'],
        'genderOther': json['genderOther'] == null ? undefined : json['genderOther'],
        'birthDate': json['birthDate'],
        'isPracticeOwner': json['isPracticeOwner'] == null ? undefined : json['isPracticeOwner'],
    };
}

export function PatientProfileDtoToJSON(json: any): PatientProfileDto {
    return PatientProfileDtoToJSONTyped(json, false);
}

export function PatientProfileDtoToJSONTyped(value?: PatientProfileDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstName': value['firstName'],
        'middleName': value['middleName'],
        'lastName': value['lastName'],
        'gender': value['gender'],
        'genderOther': value['genderOther'],
        'birthDate': value['birthDate'],
        'isPracticeOwner': value['isPracticeOwner'],
    };
}

